import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IMeetingOutCome } from "../meetingoutcomeModel";

export const getAllMeetingOutCome = createAsyncThunk(
  "MeetingOutCome/FindAllMeetingOutCome",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingOutCome/FindAllMeetingOutCome`,
        {
          meeting_outcome: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveMeetingOutCome = createAsyncThunk(
  "MeetingOutCome/FindAllActiveMeetingOutCome",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/MeetingOutCome/FindAllActiveMeetingOutCome`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching MeetingOutCome:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createMeetingOutCome = createAsyncThunk(
  "MeetingOutCome/InsertMeetingOutCome",
  async (MeetingOutComeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingOutCome/InsertMeetingOutCome`,
        MeetingOutComeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating MeetingOutCome:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateMeetingOutCome = createAsyncThunk(
  "MeetingOutCome/UpdateMeetingOutCome",
  async (MeetingOutComeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingOutCome/UpdateMeetingOutCome`,
        MeetingOutComeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating MeetingOutCome:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getMeetingOutComeByID = createAsyncThunk(
  "MeetingOutCome/FindByIDMeetingOutCome",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingOutCome/FindByIDMeetingOutCome`,
        { meeting_outcome_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        meeting_outcome: result.meeting_outcome,
        meeting_outcome_guid: result.meeting_outcome_guid,
        isactive: result.isactive === true ? 1 : 2,
      } as IMeetingOutCome;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching MeetingOutCome:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const MeetingOutComeActiveInactive = createAsyncThunk(
  "MeetingOutCome/ActiveInActiveMeetingOutCome",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingOutCome/ActiveInActiveMeetingOutCome`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive MeetingOutCome:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteMeetingOutCome = createAsyncThunk(
  "MeetingOutCome/DeleteMeetingOutCome",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingOutCome/DeleteMeetingOutCome`,
        { meeting_outcome_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting outcomeofservice:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
